import React from "react";
import { SupButton, SupText } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";

interface UiWidgetChainSelectorActionBarProps {
  onClear?: () => void;
  onSelectAll?: () => void;
  isClearDisabled?: boolean;
  isDisabled?: boolean;
}

export default function UiWidgetChainSelectorActionBar({ onClear, onSelectAll, isClearDisabled = false, isDisabled = false }: UiWidgetChainSelectorActionBarProps) {
  const hasClearAll = Boolean(onClear);
  const hasSelectAll = Boolean(onSelectAll);

  return (
    (hasClearAll || hasSelectAll) && (
      <div className="flex w-full items-center justify-between">
        {onClear && (
          <SupButton
            disabled={isClearDisabled}
            variant="text"
            className={twMerge(isClearDisabled ? "cursor-not-allowed" : "underline", "underline-offset-2 hover:no-underline")}
            onClick={() => onClear()}
          >
            <SupText variant="caption">Clear All</SupText>
          </SupButton>
        )}
        {onSelectAll && (
          <SupButton
            disabled={isDisabled}
            variant="text"
            className={twMerge(isDisabled ? "cursor-not-allowed" : "underline", "underline-offset-2 hover:no-underline")}
            onClick={() => onSelectAll()}
          >
            <SupText variant="caption">Select All</SupText>
          </SupButton>
        )}
      </div>
    )
  );
}
